import type { CellContext } from '@tanstack/react-table';
import * as React from 'react';
import type { WrappedFieldArrayProps } from 'redux-form';

import { prettyBytes } from '@acceligentllc/shared/utils/formatting';

import type { SimpleTableRow } from 'af-fields/SimpleTable';
import SimpleTable from 'af-fields/SimpleTable';

import type { AttachmentFM } from './formModel';
import styles from './styles.module.scss';

export interface OwnProps {
	initialized: boolean;
	removeRow: (index: number) => void;
}

type Props = OwnProps & WrappedFieldArrayProps<AttachmentFM>;

const AttachmentItems: React.FC<Props> = (props) => {
	const { initialized, removeRow, fields } = props;

	const columns = React.useMemo(() => [{
		id: 'name',
		header: 'File Name',
		accessor: 'fileName',
		size: 200,
		cell: (_cell: CellContext<AttachmentFM & SimpleTableRow, string>) => (
			<div className={styles.cell}>
				{_cell.getValue()}
			</div>
		),
	},
	{
		id: 'size',
		header: 'Size',
		accessor: 'size',
		cell: (_cell: CellContext<AttachmentFM & SimpleTableRow, number>) => (
			<div className={styles.cell}>
				{prettyBytes(_cell.getValue())}
			</div>
		),
	},
	], []);

	return (
		<div className={styles.attachmentTable}>
			<SimpleTable
				allowDeleteOnly={true}
				allowEdit={true}
				columns={columns}
				fields={fields}
				initialized={initialized}
				onDelete={removeRow}
			/>
		</div>
	);
};

export default React.memo(AttachmentItems);
